export const INSTALLATION_ROUTES = {
    BASE: "/installation",
    SPACES: "/installation/[companyId]/locations/[locationId]/spaces",
    SPACES_EDIT:
        "/installation/[companyId]/locations/[locationId]/spaces/[spaceId]/edit",
    SUMMARY: "/installation/[companyId]/locations/[locationId]/summary",
    DEVICES: "/installation/[companyId]/locations/[locationId]/devices",
    LOGS: "/installation/[companyId]/locations/[locationId]/logs",
};
